import * as React from "react";
import {useEffect, useState} from "react";
import {FormattedMessage} from "react-intl";
import {INavigationGroup, INavigationMenu} from "../../../utils/navigationUtils";
import {handleEnter} from "../../../utils/commonUtil";
import {useClickOutside} from "../../../utils/UseClickOutside";

export interface IHeaderNavDropdownProps {
    group: INavigationGroup;
    items: INavigationMenu[];
    currentNavigationTab?: string;
    onNavigate: (path: string, id: string) => void;
}

export const HeaderNavDropdown: React.FC<IHeaderNavDropdownProps> = (props) => {
    const [open, setOpen] = useState(false);
    const {targetRef} = useClickOutside(() => setOpen(false));

    useEffect(() => {
        const handleEscape = (e: KeyboardEvent) => {
            if (e.key === "Escape" && open) {
                setOpen(false);
            }
        };
        document.addEventListener("keydown", handleEscape);
        return () => document.removeEventListener("keydown", handleEscape);
    }, [open]);

    const isGroupSelected = props.items.some((item) => item.id === props.currentNavigationTab);
    const triggerClass =
        `navigation-tab old-anchor header-nav-dropdown__trigger clickable${isGroupSelected ? " selected" : ""}`;
    const getItemTabIndex = () => (open ? 0 : -1);

    const navigateAndClose = (path: string, id: string) => {
        props.onNavigate(path, id);
        setOpen(false);
    };

    return (
        <div className="header-nav-dropdown"
             ref={targetRef}
             data-testid={`header-nav-dropdown__${props.group.id}`}>
            <a
                id={`header-nav-dropdown__${props.group.id}`}
                className={triggerClass}
                role="button"
                tabIndex={0}
                aria-haspopup="true"
                aria-expanded={open}
                onClick={() => setOpen(!open)}
                onKeyUp={handleEnter(() => setOpen(!open))}
            >
                <FormattedMessage id={`header.${props.group.id}`} defaultMessage={props.group.defaultLabel}/>
                <i className={`fa-regular fa-chevron-${open ? "up" : "down"} header-nav-dropdown__caret`}
                   aria-hidden="true"/>
            </a>
            <div className={`header-nav-dropdown__menu header-nav-dropdown__menu--${open ? "shown" : "hidden"}`}>
                {props.items.map((item) => {
                    const itemClass = `header-nav-dropdown__item old-anchor clickable${
                        item.id === props.currentNavigationTab ? " selected" : ""}`;
                    return (
                        <a key={item.elementId}
                           id={item.elementId}
                           tabIndex={getItemTabIndex()}
                           className={itemClass}
                           onClick={() => navigateAndClose(item.path, item.id)}
                           onKeyUp={handleEnter(() => navigateAndClose(item.path, item.id))}>
                            {item.icon && <i className={`${item.icon} header-nav-dropdown__icon`} aria-hidden="true"/>}
                            <FormattedMessage id={`header.${item.id}`} defaultMessage={item.label}/>
                        </a>
                    );
                })}
            </div>
        </div>
    );
};
